/* eslint-disable @typescript-eslint/no-unused-vars */
import type { AppState } from "@appsmith/reducers";
import type { ModuleInstance } from "@appsmith/constants/ModuleInstanceConstants";

export const getModuleInstanceById = (
  state: AppState,
  id: string,
): ModuleInstance | undefined => undefined;
